// MATERIAL UI
import { Box, Typography } from "@mui/material";

// ICONS
import CreditCardIcon from "@mui/icons-material/CreditCard";

interface BalanceDisplayProps {
  code?: string;
  balance?: string | number;
  showCode?: boolean;
  backgroundColor?: string;
  children?: React.ReactNode;
  isPreFormatted?: boolean;
}

export const BalanceDisplay = ({
  code,
  balance,
  showCode = true,
  backgroundColor = "#F8F9F9",
  children,
  isPreFormatted = false,
}: BalanceDisplayProps): JSX.Element => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      padding="8px"
      sx={{
        borderRadius: "8px",
        backgroundColor,
        gap: "12px",
      }}>
      <CreditCardIcon sx={{ color: "#5C6469" }} />
      <Typography fontFamily="Roobert" fontSize="16px" color="#5C6469">
        {showCode && code && code !== "Select" && code}{" "}
        {balance && (isPreFormatted ? balance : Number(balance).toLocaleString())}
      </Typography>
      {children}
    </Box>
  );
};
